'use strict';

const disassembleISODatePartWithoutYearToParts = (isoDatePart) => {
  const parts = isoDatePart.split("-").map(Number);
  return {
    month: parts[2],
    day: parts[3]
  };
};

module.exports = disassembleISODatePartWithoutYearToParts;
//# sourceMappingURL=disassembleISODatePartWithoutYearToParts.cjs.map
